<template>
  <el-dialog
    :append-to-body="true"
    :title="type == 'add' ? '新增留守儿童档案' : '修改留守儿童档案'"
    :visible.sync="show"
    direction="ltr"
    :before-close="handleClose"
    width="800px"
    :wrapperClosable="false"
    :close-on-press-escape="false"
  >
  <div style="height:50vh;overflow-y: scroll;">

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
    >
      <el-form-item label="学生:" prop="studentName">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.studentName"
          placeholder="请输入学生姓名"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="班级名称:" prop="className">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.className"
          placeholder="请输入班级名称"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别:" prop="gender">
        <el-select
          style="width:95%"
          v-model="ruleForm.gender"
          placeholder="请选择性别"
          clearable
          size="small"
        >
          <el-option
            v-for="item in $store.state.select.personnelSex"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学生生日:" prop="studentBirthday">
        <el-date-picker
          size="small"
          style="width:95%"
          v-model.trim="ruleForm.studentBirthday"
          type="date"
          clearable
          value-format="timestamp"
          placeholder="选择学生生日"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="家长姓名:" prop="parentName">
        <el-input
          v-model.trim="ruleForm.parentName"
          placeholder="请输入家长姓名"
          clearable
          style="width:95%"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话:" prop="parentPhone">
        <el-input
          v-model.trim="ruleForm.parentPhone"
          placeholder="请输入家长联系电话"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="外出情况:" prop="parentGoOutStatus">
        <el-select
          style="width:95%"
          v-model="ruleForm.parentGoOutStatus"
          placeholder="请选择父母外出情况"
          clearable
          size="small"
        >
          <el-option
            v-for="item in $store.state.select.parentSituation"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="外出地址:" prop="parentGoOutAddr">
        <el-input
          v-model.trim="ruleForm.parentGoOutAddr"
          placeholder="请输入父母外出地址"
          clearable
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 2 }"
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="回家频次:" prop="parentGetHomeNum">
        <el-input
          v-model.trim="ruleForm.parentGetHomeNum"
          placeholder="请输入父母外出后回家频次"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="从事工作:">
        <el-input
          v-model.trim="ruleForm.parentWork"
          placeholder="请输入父母外出从事工作"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="临时监护人:" prop="guardianName">
        <el-input
          v-model.trim="ruleForm.guardianName"
          placeholder="请输入临时监护人"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="关系:" prop="guardianRelationship">
        <el-input
          v-model.trim="ruleForm.guardianRelationship"
          placeholder="请输入与临时监护人关系"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系方式:" prop="guardianPhone">
        <el-input
          v-model.trim="ruleForm.guardianPhone"
          placeholder="请输入临时监护人联系方式"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="居住地址:" prop="guardianAddr">
        <el-input
          v-model.trim="ruleForm.guardianAddr"
          placeholder="请输入临时监护人居住地址"
          clearable
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="帮扶老师姓名:" prop="helpTeacherName">
        <el-input
          v-model.trim="ruleForm.helpTeacherName"
          placeholder="请输入帮扶老师姓名"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话:" prop="helpTeacherPhone">
        <el-input
          v-model.trim="ruleForm.helpTeacherPhone"
          placeholder="请输入帮扶老师联系电话"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="所教学科:" prop="helpTeacherSub">
        <el-input
          v-model.trim="ruleForm.helpTeacherSub"
          placeholder="请输入帮扶老师所教学科"
          clearable
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      <el-form-item label="生活情况简介:">
        <el-input
          v-model.trim="ruleForm.content"
          placeholder="请输入生活情况简介"
          clearable
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          size="small"
          style="width:95%"
        ></el-input>
      </el-form-item>
      
    </el-form>
  </div>
  <span slot="footer">
        <el-button
          type="primary"
          size="small"
          @click="saveForm('ruleForm')"
          v-loading="saveLoading"
          >提交</el-button
        >
        <el-button @click="handleClose" size="small" v-loading="saveLoading"
          >取消</el-button
        >
      </span>
  </el-dialog>
</template>
<script>
export default {
  name: "AddOrEditChildern",
  props: {
    drawerShow: {
      type: Boolean,
      default: {
        return: false
      }
    },
    drawerType: {
      type: String,
      default: {
        return: ""
      }
    },
    initialData: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    var num = /^[0-9]*[1-9][0-9]*$/;
    var checkNum = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!num.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      show: false,
      type: "",
      ruleForm: {
        schoolId: "",
        studentName: "", //学生姓名
        className: "", //班级名称
        gender: "", //性别
        studentBirthday: "", //学生生日
        parentName: "", //家长姓名
        parentPhone: "", //家长电话
        parentGoOutStatus: "", //父母外出情况
        parentGoOutAddr: "", //父母外出地址
        parentGetHomeNum: "", //父母外出后回家频次
        parentWork: "", //父母外出从事工作
        guardianName: "", //临时监护人
        guardianRelationship: "", //与临时监护人关系
        guardianPhone: "", //临时监护人联系方式
        guardianAddr: "", //临时监护人居住地址
        helpTeacherName: "", //帮扶老师姓名
        helpTeacherPhone: "", //帮扶老师联系电话
        helpTeacherSub: "", //帮扶老师所教学科
        content: "" //生活情况简介
      },
      saveLoading: false,
      rules: {
        studentName: [{ required: true, message: " ", trigger: "blur" }],
        className: [{ required: true, message: " ", trigger: "blur" }],
        gender: [{ required: true, message: " ", trigger: "change" }],
        studentBirthday: [{ required: true, message: " ", trigger: "change" }],
        parentName: [{ required: true, message: " ", trigger: "blur" }],
        parentGoOutStatus: [
          { required: true, message: " ", trigger: "change" }
        ],
        parentPhone: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        parentGoOutAddr: [{ required: true, message: " ", trigger: "blur" }],
        parentGetHomeNum: [
          { required: true, validator: checkNum, trigger: "blur" }
        ],
        guardianName: [{ required: true, message: " ", trigger: "blur" }],
        guardianRelationship: [
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ],
        guardianPhone: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        guardianAddr: [
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ],
        helpTeacherName: [{ required: true, message: " ", trigger: "blur" }],
        helpTeacherPhone: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        helpTeacherSub: [
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addOrEditForm();
        } else {
          return false;
        }
      });
    },
    async addOrEditForm() {
      this.saveLoading = true;
      this.ruleForm.schoolId = this.$store.state.schoolId || "";
      let req = Object.assign({}, this.ruleForm);
      if (this.type == "add") {
        delete req.id;
      }
      req.studentBirthday = parseInt(req.studentBirthday) / 1000;
      let res = await this.$Http.addOrEditChildrenFile(req, true);
      this.saveLoading = false;
      if (res.code == 200) {
        this.$emit("saveData");
      } else {
        this.$message({
          message: res.messsage || "提交失败",
          type: "error"
        });
      }
    },
    //   关闭抽屉
    handleClose() {
      this.$emit("handleClose");
    }
  },
  watch: {
    drawerShow: function(nval) {
      this.show = nval;
      if (nval) {
        this.type = this.drawerType || "";
        this.ruleForm = Object.assign({}, this.initialData);
      } else {
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
